<template>
  <div class="login" @click.stop="bindStop">
    <div class="container">
      <div class="title">登录</div>
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="form">
        <div class="content-item">
          <div class="item-top">手机号</div>
          <div class="item-bottom phone-number-content">
            <div class="phone-area" @click="changeAreaCode"
              ><span>+{{ areaCode }}</span
              ><span class="iconfont icon-xiala"></span
            ></div>
            <div class="line"></div>
            <input
              type="number"
              v-model="phone"
              class="input"
              placeholder="请输入手机号码"
            />
          </div>
        </div>
        <div class="content-item">
          <div class="item-top">验证码</div>
          <div class="item-bottom">
            <input
              type="number"
              class="input"
              v-model="code"
              placeholder="请输入验证码"
              maxlength="6"
            />
            <div class="item-code" v-if="codeTime">{{ codeTime }}</div>
            <div class="item-code" v-else @click="bindSendCode"
              >获取验证码
            </div>
          </div>
        </div>
        <div
          class="confirm-btn"
          :class="{ 'btn-disabled': disabledLogin }"
          @click="bindLogin"
        >
          确认
        </div>
      </div>
    </div>
    <AreaCode
      v-if="showArea"
      @change="bindChange"
      @close="bindAreaClose"
    ></AreaCode>
  </div>
</template>
<script>
import AreaCode from './area-code/index.vue'
export default {
  components: {
    AreaCode
  },
  props: {
    zIndex: {
      type: String | Number,
      default: 1
    }
  },
  data() {
    return {
      disabledSend: false, //是否禁用发送验证码
      codeTime: 0, //验证码等待时间
      timer: null,
      phone: '',
      code: '',
      areaCode: '86',
      showArea: false
    }
  },
  computed: {
    disabledLogin() {
      let disabledLogin = !this.phone || !this.code
      return disabledLogin
    }
  },
  watch: {
    code(val) {
      if (val.length > 4) {
        this.code = val.slice(0, 4)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    changeAreaCode() {
      this.showArea = true
    },
    bindChange(code) {
      this.areaCode = code
      this.showArea = false
    },
    bindAreaClose() {
      this.showArea = false
    },
    bindClose() {
      this.$emit('close')
    },
    bindStop() {},
    bindSendCode() {
      if (this.disabledSend) {
        return
      }
      if (!this.checkPhone(this.phone)) {
        this.$toast('请检查手机号码长度')
        return
      }
      this.disabledSend = true
      let params = {
        phone: this.phone,
        areaCode: this.areaCode
      }
      this.$http
        .postBaseApp('sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('发送成功')
            this.codeInterval()
          } else {
            this.disabledSend = false
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledSend = false
        })
    },
    codeInterval() {
      this.codeTime = 60
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          this.disabledSend = false
          clearInterval(this.timer)
          // this.codeTime = 0;
        }
      }, 1000)
    },
    checkParams() {
      let res = this.checkPhone(this.phone) && this.checkCode(this.code)
      return res
    },
    checkPhone(phone) {
      if (!phone.length) {
        this.$toast('请输入电话号码')
        return false
      }
      if (phone.length != 11) {
        this.$toast('请检查手机号码长度')
        return false
      }
      return true
    },
    checkCode(code) {
      code = code.trim()
      if (!code) {
        this.$toast('请输入验证码')
      }
      return code
    },
    bindLogin() {
      if (this.disabledLogin) {
        return
      }
      if (!this.checkParams()) {
        return
      }
      let params = {
        phone: this.phone,
        identify_code: this.code,
        areaCode: this.areaCode
      }
      this.$http
        .postBaseApp('que/QueBase/getUserToken', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('登录成功')
            localStorage.setItem('token', res.data)
            sessionStorage.setItem('token', res.data)
            setTimeout(() => {
              this.$emit('login')
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: #fff;
  box-sizing: border-box;
  animation: moveup 0.3s ease;
  overflow-y: scroll;

  .container {
    padding: 38px;
  }

  .title {
    text-align: center;
    margin-top: 20vh;
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000;
    margin-bottom: 18px;
  }

  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    left: 5px;
    color: #000;
    font-size: 18px;
  }

  .form {
    .content-item {
      margin-top: 11px;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      font-size: 13px;

      .item-top {
        width: 100%;
        //text-indent: 21px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.5);
        margin-bottom: 8px;
      }

      .item-bottom {
        width: 100%;
        display: flex;
        align-items: center;

        .phone-area {
          height: 36px;
          line-height: 36px;
          white-space: nowrap;
          padding: 0px 12px 0px 20px;
          background: #f7f7f7;
          border-radius: 10px;
          border: 1px solid #f1f1f1;
          display: flex;
          align-items: center;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.3);
          line-height: 18px;

          .icon-youjiantou {
            transform: rotate(90deg);
            color: #d8d8d8;
            margin-left: 10px;
          }
        }

        .line {
          margin: 0px 6px;
          width: 8px;
          height: 1px;
          background-color: #ddd;
        }

        .input {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          width: 100%;
          padding: 0px 20px;
          box-sizing: border-box;
          font-weight: 700;
          height: 36px;
          background-color: #f7f7f7;
          border-radius: 10px;
          border: solid 1px #f1f1f1;
        }
      }

      .item-code {
        width: 110px;
        text-align: center;
        box-sizing: border-box;
        padding: 9px 5px;
        border-radius: 10px;
        border: 1px solid #f1f1f1;
        margin-left: 10px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #000000;
      }
    }
  }

  .confirm-btn {
    margin-top: 30px;
    height: 44px;
    line-height: 44px;
    background: #6236ff;
    border-radius: 12px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .btn-disabled {
    background: rgba(0, 0, 0, 0.1);
  }
}

@keyframes moveup {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0%);
  }
}
</style>
